export default __webpack_public_path__ + "static/media/positive.9ca3510a.svg";